import { collectionPath, defineModelSpec, orderBy } from '@elara/firebolt/shared';

import { ShortlistGroupSchema } from './schemas/shortlist-schemas.js';
import { id, tripId } from './schemas/zod-types.js';

/**
 * The canonical `ModelSpec` for the shortlist-groups subcollection within a trip.
 * It defines the path (`trips/{tripId}/shortlist-groups/{id}`) and the data shape for a shortlist group document.
 * Shortlist groups allow users to organize shortlist items for comparison.
 */
export const ShortlistGroupModelSpec = defineModelSpec({
  path: collectionPath`trips/${tripId}/shortlist-groups/${id}`,
  shape: ShortlistGroupSchema.shape,
  constraints: [orderBy('position', 'asc')],
});

export type ShortlistGroupModelSpec = typeof ShortlistGroupModelSpec;
export type ShortlistGroupData = ShortlistGroupModelSpec['DataType'];

